import { useEffect, useState } from 'react';

import { ImageSize } from './useImageSize.common';

const useImageSize = (uri: string, deviceWidth: number, maxWidth: number): ImageSize => {
  const [imageSize, setImageSize] = useState<ImageSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!uri) return;

    const img = new Image();
    img.onload = () => {
      const intrinsicWidth = img.naturalWidth;
      const intrinsicHeight = img.naturalHeight;

      const displayWidth = deviceWidth <= maxWidth ? deviceWidth : maxWidth;
      const displayHeight = (displayWidth / intrinsicWidth) * intrinsicHeight;

      setImageSize({ width: displayWidth, height: displayHeight });
    };
    img.src = uri;
  }, [uri, deviceWidth, maxWidth]);

  return imageSize;
};

export default useImageSize;
